import i18n from 'i18next';

import {
	CheckinSegmentFragment,
	GdsService_OrderAdditionalServiceGdsServiceBaggage_Fragment,
	GdsService_OrderAdditionalServiceGdsServiceMeal_Fragment,
	IncludedGdsServicesFragment,
	PassengerSelectedGdsServicesProductFragment,
	SegmentFragment
} from '@websky/graphql';
import { ServiceOptionItem } from '../../../ServiceSummary/types';

import { getActualProduct } from '../../../ServiceSummary/utils';
import { baggageOptionItemFactory } from './baggageOptionItemFactory';
import { ALL_SEGMENTS_KEY } from '@shared/lib/flight';

export function includedOptionItemFactory({
	key,
	travellerId,
	segmentsGroupsCount,
	segments,
	includedService,
	products = []
}: {
	key: string;
	travellerId: string;
	segmentsGroupsCount: number;
	segments: (SegmentFragment | CheckinSegmentFragment)[];
	includedService: IncludedGdsServicesFragment;
	products?: PassengerSelectedGdsServicesProductFragment[];
}): ServiceOptionItem {
	const { count, confirmedCount } = includedService;

	const isAllSegments = key === ALL_SEGMENTS_KEY;
	const gdsServiceType = includedService.service.type;

	switch (gdsServiceType) {
		case 'Baggage':
			const baggageService = includedService.service as GdsService_OrderAdditionalServiceGdsServiceBaggage_Fragment;

			return baggageOptionItemFactory({
				key,
				travellerId,
				count,
				confirmedCount,
				segmentsGroupsCount,
				products,
				gdsService: baggageService,
				groupType: 'confirmed'
			});
		case 'Meal':
			const mealService = includedService.service as GdsService_OrderAdditionalServiceGdsServiceMeal_Fragment;
			const segment = !isAllSegments && segments.find(segment => segment.id === key);

			const direction = segment
				? `${segment.departure.airport.iata} – ${segment.arrival.airport.iata}`
				: i18n.t('All flights', { ns: 'Cart' });

			const actualProduct = getActualProduct(products);

			return {
				name: `${direction}, ${count}x ${mealService.name}`,
				id: mealService.id,
				segment: key,
				price: mealService.price,
				status: actualProduct?.status,
				included: count === confirmedCount
			};
		default:
			return null;
	}
}
